import { FC } from 'react';
import { QcsAutocomplete } from './QcsAutocomplete';
import { getLangNameObj } from '../../../utils/format';
import { useTranslation } from 'react-i18next';
import { useInvitation } from '../../invitation/Detail/Tabs/invitationFunctions';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { InvitationRelationResponse } from '@api/models/invitation/InvitationRelationResponse';

interface Props {
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  workplaces?: InvitationRelationResponse[];
  excludeIds?: string[];
  showEstablishmentName?: boolean;
  establishmentIds?: string[];
  style?: React.CSSProperties;
}

export const InvitationWorkplaceAutocomplete: FC<Props> = ({
  multiple,
  name,
  label,
  disabled,
  required,
  workplaces,
  excludeIds,
  showEstablishmentName,
  establishmentIds,
  style,
}) => {
  const { i18n } = useTranslation();
  const { invitation } = useInvitation();

  const getWorkplaceName = (workplace: ReferenceDto) => {
    const workplaceName = getLangNameObj(i18n, workplace);
    if (showEstablishmentName) {
      const establishment = (invitation.workplaces ?? []).find((wp) => wp.workplace?.id === workplace.id)?.establishment;
      if (!establishment) return workplaceName;
      const establishmentName = getLangNameObj(i18n, establishment);
      return `${workplaceName} | ${establishmentName}`;
    }

    return workplaceName;
  };

  const getWorkplaces = (): ReferenceDto[] => {
    if (workplaces) return workplaces.map(it => it.workplace!);
    return invitation.workplaces
      ?.filter(
        (wp) =>
          (!excludeIds || !excludeIds.includes(wp?.workplace?.id || '')) &&
          (!establishmentIds || establishmentIds?.includes(wp.establishment?.id || ''))
      )
      .map((it) => it.workplace!)
      .filter((workplace, index, self) =>
        index === self.findIndex(w => w.id === workplace.id)
      ) ?? [];
  };

  return (
    <QcsAutocomplete<ReferenceDto>
      style={style}
      multiple={multiple}
      name={name}
      label={label}
      required={required}
      disabled={disabled}
      options={getWorkplaces()}
      loading={false}
      loadingError={false}
      loadOptions={() => {}}
      getOptionId={(option) => option.id || ''}
      getOptionName={getWorkplaceName}
    />
  );
};
